import {rawHttp} from '../../services/http';
import {getReferralHtmlEndpoint, getReferralPdfEndpoint, getReferralsListEndpoint, ICD10_CODES, ICD9_CODES, ISSUE_REFERRAL, REFERRALS_ADDITIONAL_DATA} from './referralEndpoints';
import {InitializeDto} from '../../types/timeSlot';
import { rawP1Service } from '../../services/P1Service';
import { Icd10Code, Icd9CodeResponse, IssueReferralDto, ReferralResponseDto } from '../../types/referrals';
import { P1Response } from '../../types/p1Service';
import { IssueReferralResponse } from '../../types/referrals';

class ReferralApi {
    getReferralAdditionalData() {
        return rawHttp.get<InitializeDto>(REFERRALS_ADDITIONAL_DATA);
    }

    getIcd9Codes(query: string) {
        return rawP1Service.get<P1Response<Icd9CodeResponse[]>>(ICD9_CODES, { params: { query } });
    }

    getIcd10Codes(query: string) {
        return rawP1Service.get<P1Response<Icd10Code[]>>(ICD10_CODES, { params: { query } });
    }

    issueReferral(data: IssueReferralDto) {
        return rawP1Service.post<P1Response<IssueReferralResponse>>(ISSUE_REFERRAL, data);
    }

    getReferrals(appointmentId: number) {
        return rawP1Service.get<P1Response<ReferralResponseDto[]>>(getReferralsListEndpoint(appointmentId));
    }

    getReferralPdf(referralId: string) {
        return rawP1Service.get(getReferralPdfEndpoint(referralId));
    }

    getReferralHtml(referralId: string) {
        return rawP1Service.get(getReferralHtmlEndpoint(referralId));
    }

}
    
export const referralApi = new ReferralApi();
